module.exports = __webpack_public_path__ + "static/2-14b8f3183d17aa4977be361cc077e2e4.jpg";